var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "item-line" }, [_vm._v("活动计划信息")]),
      _c(
        "div",
        { staticClass: "budgetBox bodyBox" },
        [
          _c(
            "a-form-model",
            {
              ref: "activityForm",
              staticClass: "UniformCss",
              attrs: { inline: true, "label-col": { span: 8 } },
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "活动计划编码" } },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.disabled },
                            model: {
                              value: _vm.data.planCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "planCode", $$v)
                              },
                              expression: "data.planCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticClass: "act-item widthHuo",
                          attrs: {
                            label: "活动名称",
                            "label-col": { span: 3 },
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.disabled },
                            model: {
                              value: _vm.data.actName,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "actName", $$v)
                              },
                              expression: "data.actName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticClass: "act-item",
                          attrs: { label: "生效时间" },
                        },
                        [
                          _c("a-date-picker", {
                            attrs: { type: "date", disabled: "" },
                            model: {
                              value: _vm.data.planStartTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "planStartTime", $$v)
                              },
                              expression: "data.planStartTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticClass: "act-item",
                          attrs: { label: "失效时间" },
                        },
                        [
                          _c("a-date-picker", {
                            attrs: { type: "date", disabled: "" },
                            model: {
                              value: _vm.data.planEndTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "planEndTime", $$v)
                              },
                              expression: "data.planEndTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticClass: "act-item",
                          attrs: {
                            label: "市场活动来源",
                            "label-col": { span: 4 },
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.disabled },
                            model: {
                              value: _vm.selectedOrgText,
                              callback: function ($$v) {
                                _vm.selectedOrgText = $$v
                              },
                              expression: "selectedOrgText",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticClass: "act-item",
                          attrs: { label: "费用额度(元)" },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.disabled },
                            model: {
                              value: _vm.formattedFeeLimit,
                              callback: function ($$v) {
                                _vm.formattedFeeLimit = $$v
                              },
                              expression: "formattedFeeLimit",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticClass: "act-item",
                          attrs: { label: "核销比例(%)" },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.disabled },
                            model: {
                              value: _vm.data.writeRate,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "writeRate", $$v)
                              },
                              expression: "data.writeRate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticClass: "act-item",
                          attrs: { label: "执行频次" },
                        },
                        [
                          _c("a-input", {
                            attrs: { disabled: _vm.disabled },
                            model: {
                              value: _vm.data.executeFreq,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "executeFreq", $$v)
                              },
                              expression: "data.executeFreq",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { staticStyle: { height: "auto" }, attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticClass: "width100Px",
                          attrs: {
                            label: "其他说明",
                            "label-col": { span: 4 },
                          },
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "100%" },
                            attrs: { disabled: _vm.disabled, type: "textarea" },
                            model: {
                              value: _vm.data.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "remarks", $$v)
                              },
                              expression: "data.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { staticStyle: { height: "auto" }, attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticClass: "width100Px",
                          attrs: {
                            label: "核销规则",
                            "label-col": { span: 4 },
                          },
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "100%" },
                            attrs: { disabled: _vm.disabled, type: "textarea" },
                            model: {
                              value: _vm.data.writeOffRules,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "writeOffRules", $$v)
                              },
                              expression: "data.writeOffRules",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { staticStyle: { height: "auto" }, attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticClass: "width100Px",
                          attrs: {
                            label: "核销材料说明",
                            "label-col": { span: 4 },
                          },
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "100%" },
                            attrs: { disabled: _vm.disabled, type: "textarea" },
                            model: {
                              value: _vm.data.writeOffMaterial,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "writeOffMaterial", $$v)
                              },
                              expression: "data.writeOffMaterial",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { staticStyle: { height: "auto" }, attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticClass: "width100Px",
                          attrs: {
                            label: "核销其他说明",
                            "label-col": { span: 4 },
                          },
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "100%" },
                            attrs: { disabled: _vm.disabled, type: "textarea" },
                            model: {
                              value: _vm.data.writeOffOther,
                              callback: function ($$v) {
                                _vm.$set(_vm.data, "writeOffOther", $$v)
                              },
                              expression: "data.writeOffOther",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "执行车系",
            visible: _vm.showCarSeries,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCarSeries = $event
            },
          },
        },
        [
          _c(
            "vxe-table",
            {
              ref: "xTable",
              staticClass: "mytable-scrollbar",
              staticStyle: { "margin-top": "10px" },
              attrs: {
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                "max-height":
                  _vm.$store.state.app.height - 350 < 185
                    ? 185
                    : _vm.$store.state.app.height - 350,
                "scroll-y": { enabled: false },
                "row-config": { isHover: true },
                data: _vm.carStrainList,
              },
            },
            [
              _c("vxe-column", {
                attrs: {
                  type: "seq",
                  title: "序号",
                  width: "60",
                  align: "center",
                },
              }),
              _c("vxe-column", {
                attrs: { title: "品系", field: "strains", align: "center" },
              }),
              _c("vxe-column", {
                attrs: { title: "车系", field: "carSeries", align: "center" },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showCarSeries = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }